import Vue from 'vue'
import router from './router'
import { ACCESS_TOKEN } from './utils/globalConst'
const whiteList = ['login']
router.beforeEach((to, from, next) => {
    if (Vue.ls.get(ACCESS_TOKEN)) {
        // if (to.name == 'login') {

        // }else{

        // }

        next()
    } else {
        if (whiteList.includes(to.name)) {
            // 在免登录白名单，直接进入
            next()
        } else {
            next({ path: '/login', query: { redirect: to.fullPath } })
        }
    }

})